import { Link } from "react-router-dom";

const FOOTER_LOGO_SRC = encodeURI("/Focus Traffic Plans-Final.png");

const serviceLinks = [
  { label: "Council Permits", to: "/services/council-permits" },
  { label: "Construction Traffic Management Plans", to: "/services/construction-traffic-management-plans" },
  { label: "Pedestrian Control Plans", to: "/services/pedestrian-control-plans" },
  { label: "Road Closure & Detour Plans", to: "/services/road-closure-detour-plans" },
  { label: "Traffic Guidance Schemes", to: "/services/traffic-guidance-scheme" },
];

const companyLinks = [
  { label: "Industries", href: "https://focustraffic.com.au/#services" },
  { label: "News", href: "https://focustraffic.com.au/news" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact Us", to: "/contact" },
];

function SocialButton({ href, label, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="flex h-10 w-10 items-center justify-center rounded-full bg-zinc-800 text-white transition-colors hover:bg-zinc-700"
    >
      {children}
    </a>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-white pb-6 pt-2">
      <div className="mx-auto w-full max-w-[96rem] px-2 pb-10 pt-2 sm:px-3 md:px-5 lg:px-7">
        <div className="rounded-2xl border border-white/10 bg-[#1a1a1a] px-6 py-12 text-white shadow-xl shadow-black/25 sm:rounded-3xl sm:px-8 sm:py-14 lg:px-10 lg:py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-5 lg:gap-8 [&>*]:min-w-0">
          {/* Brand */}
          <div className="lg:pr-4">
            <div className="mb-5">
              <img
                src={FOOTER_LOGO_SRC}
                alt="Focus Traffic Plans"
                className="h-14 w-auto max-w-[min(100%,260px)] object-contain object-left"
                width={260}
                height={56}
                decoding="async"
              />
            </div>
            <p className="text-sm leading-relaxed text-white/80">
              Professional traffic plans across Australia. Safety-focused, fully
              compliant, always reliable.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <SocialButton href="https://www.linkedin.com/company/108843651/" label="LinkedIn">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </SocialButton>
              <SocialButton href="https://www.youtube.com/@FocusTrafficManagement" label="YouTube">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </SocialButton>
              <SocialButton href="https://www.instagram.com/focustrafficmanagement/" label="Instagram">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </SocialButton>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="mb-5 text-xs font-bold uppercase tracking-widest text-white">
              Services
            </h3>
            <ul className="space-y-3 text-sm">
              {serviceLinks.map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="text-white/80 transition-colors hover:text-orange-500"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="mb-5 text-xs font-bold uppercase tracking-widest text-white">
              Company
            </h3>
            <ul className="space-y-3 text-sm">
              {companyLinks.map(({ label, to, href }) => (
                <li key={label}>
                  {to ? (
                    <Link
                      to={to}
                      className="text-white/80 transition-colors hover:text-orange-500"
                    >
                      {label}
                    </Link>
                  ) : (
                    <a
                      href={href}
                      className="text-white/80 transition-colors hover:text-orange-500"
                      {...(href?.startsWith("http")
                        ? { target: "_blank", rel: "noopener noreferrer" }
                        : {})}
                    >
                      {label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Our Brands */}
          <div>
            <h3 className="mb-5 text-xs font-bold uppercase tracking-widest text-white">
              Our Brands
            </h3>
            <a
              href="https://focustraffic.com.au/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex max-w-full items-center gap-2.5 text-sm font-semibold text-white/80 transition-colors hover:text-orange-500"
            >
              <img
                src="/focus-traffic-management-icon.png"
                alt=""
                width={22}
                height={22}
                className="h-[22px] w-[22px] shrink-0 rounded-md object-contain"
              />
              Focus Traffic Management
            </a>
          </div>

          {/* Contact */}
          <div>
            <h3 className="mb-5 text-xs font-bold uppercase tracking-widest text-white">
              Contact
            </h3>
            <ul className="space-y-4 text-sm text-white/80">
              <li className="flex gap-3">
                <svg
                  className="mt-0.5 h-5 w-5 shrink-0 text-orange-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <a
                  href="tel:1300118170"
                  className="leading-snug text-white/80 transition-colors hover:text-orange-500"
                >
                  1300 118 170
                </a>
              </li>
              <li className="flex gap-3">
                <svg
                  className="mt-0.5 h-5 w-5 shrink-0 text-orange-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href="mailto:info@focustrafficplans.com.au"
                  className="block max-w-full break-all leading-snug text-white/80 transition-colors hover:text-orange-500"
                >
                  info@focustrafficplans.com.au
                </a>
              </li>
              <li className="flex gap-3">
                <svg
                  className="mt-0.5 h-5 w-5 shrink-0 text-orange-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="leading-snug">
                  Suite 4.04, 5 Celebration Drive
                  <br />
                  Bella Vista NSW 2153
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8">
          <div className="grid grid-cols-1 items-center gap-6 text-sm leading-5 text-white/70 sm:grid-cols-[minmax(0,1fr)_auto] sm:gap-x-8">
            <div className="flex flex-col gap-1">
              <p>© {year} Focus Traffic Management. All rights reserved.</p>
              <p>Focus Traffic Plans is a trading name of Focus Traffic Management.</p>
              <p>ABN: 23 659 805 231</p>
            </div>
            <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 sm:justify-end">
              <Link to="/terms" className="text-white/70 transition-colors hover:text-orange-500">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-white/70 transition-colors hover:text-orange-500">
                Privacy Policy
              </Link>
              <Link to="/cookies" className="text-white/70 transition-colors hover:text-orange-500">
                Cookies
              </Link>
            </nav>
          </div>
        </div>
        </div>
      </div>
    </footer>
  );
}
